import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface RenameResidenceDialogData {
    currentName: string;
}

@Component({
    selector: 'app-rename-residence-dialog',
    templateUrl: './rename-residence-dialog.component.html',
    styleUrls: ['./rename-residence-dialog.component.scss'],
})
export class RenameResidenceDialogComponent {
    public nameControl = new FormControl(this.data.currentName, [Validators.required, Validators.minLength(2), Validators.maxLength(100)]);

    constructor(
        public dialogRef: MatDialogRef<RenameResidenceDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: RenameResidenceDialogData,
    ) {}

    confirm(): void {
        this.nameControl.markAsTouched();
        if (!this.nameControl.valid) return;
        this.dialogRef.close(this.nameControl.value.trim());
    }

    cancel(): void {
        this.dialogRef.close(null);
    }
}
